import { InvoiceDetails, InvoiceDocumentOrder } from "@/models/accounting";
import { formatAmount } from "@/util";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface IAccountingInvoiceTabProps {
    selectedInvoice: InvoiceDocumentOrder | null;
    invoiceDetails: InvoiceDetails | undefined;
}

const AccountingInvoiceTab: FC<IAccountingInvoiceTabProps> = (props: IAccountingInvoiceTabProps) => {
    const { t } = useTranslation();

    return (
        <div className="accounting-receipt-tab-container">
            <div className="accounting-receipt-tab-header">
                {t("enums.AccountingDocType.Invoice")} #{props.selectedInvoice?.docket}
            </div>
            <div className="accounting-receipt-tab-content">
                <div className="accounting-receipt-tab-content-data">
                    <div className="transaction-tab-text">
                        <div>{t("accounting.connectedInvoicesQTY")}:</div>
                        <div>{t("accounting.documentType")}:</div>
                    </div>
                    <div className="transaction-tab-data">
                        <div>{props.invoiceDetails?.connectedOrdersQty}</div>
                        <div>{t(`enums.AccountingDocType.${props.invoiceDetails?.docType}`)}</div>
                    </div>
                </div>
                <div className="accounting-receipt-tab-content-data-second">
                    <div className="transaction-tab-text">
                        <div>{t("accounting.docAmount")}:</div>
                    </div>
                    <div className="transaction-tab-data">
                        <div>{formatAmount(props.selectedInvoice?.total, props.selectedInvoice?.currencyId)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountingInvoiceTab;
